import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { DiveAT } from '../../../../shared/models/component-messages/diveAT/diveAT';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { LogService } from '../../../../shared/services/log.service';
import { TypeAnn } from '../../../common/models/type.ann';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G2 } from '../models/TypeAnn_DIVER_G2';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';
import { SpinnerVisibilityService } from 'ng-http-loader';


@Component({
  selector: 'app-form-divers-attribution',
  templateUrl: './formDiversAttribution.component.html'
})
export class FormDiversAttributionComponent implements OnInit, OnChanges {

  private LOG: LogService = new LogService(FormDiversAttributionComponent);

  @Input() indexPage: any;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public createForm = false;
  public ann = new TypeAnn();
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;

  public attribution = new TypeAnn_DIVER_G2();
  public diveAt = new DiveAT();
  public current_uid = 'Attribution';
  private isLierAvisSelected :boolean=false;

  public steps = [4, 5, 6, 7, 8, 9, 10, 11];
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private annonceurService: AnnonceurService,
    private spinner: SpinnerVisibilityService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 12 }, (_, index) => index + 1);
    this.initForm();
  }

  /**
   * Met à jour le modèle ann depuis avisDataTransferService quand indexPage change.
   * Cela garantit que les composants enfants (steps) reçoivent les données à jour
   * après une sauvegarde et navigation entre les étapes.
   */
  public ngOnChanges(changes: SimpleChanges) {
    if (changes['indexPage'] && !changes['indexPage'].firstChange && this.createForm) {
      const formData = this.avisDataTransferService.getFormData();
      if (formData?.jsonSaisieFormulaire?.ann) {
        this.ann = formData.jsonSaisieFormulaire.ann;
      }
    }
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4) {
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        }

        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.createForm = true;
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.DIVE_AT, JsonContentEnum.EMPTY, data).subscribe(data => {
	        this.createForm = true;
          this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
          this.ann = data.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=data.refConsultation;
          this.avisDataTransferService.siret=data.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(data);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(data.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.DIVE_AT] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:data});
                return json;
              }
            );
          } else {
            this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.DIVE_AT] + '.json');
            this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.DIVE_AT] + '.json');
            this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.DIVE_AT] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  public getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Attribution';
  }

  getUidCommon(indexPage) {
    return (
      '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn'
    );
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(
      this.diveAt.step + indexPage
    )
      ? this.diveAt.step + indexPage
      : this.diveAt.commonStep + indexPage;
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]:
        return [];
      case this.steps[1]:
        return [];
      case this.steps[2]:
        return [];
      case this.steps[3]:
        return [];
      case this.steps[4]:
        return [];
      case this.steps[5]:
        return [];
      case this.steps[6]:
        return [];
      case this.steps[7]:
        return [];
    }
  }

}
